export default __webpack_public_path__ + "static/icon-12-4-69cfae2a2b031a962cd2d1861dc1b64e.png";